module.exports = __webpack_public_path__ + "img/img_off@3x.1de304c1.png";